module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1178.b5505557.png";